import { useCallback, useState } from 'react'

import { GenerateTrialPatientVideoCallTokenDocument } from 'src/lib/gql-client'
import { useGqlMutation } from 'src/lib/gql-client/request'

type State = {
  token: string
  videoCallUserUid: number
  screenShareUserUid: number
  screenShareToken: string
  videoCallRoomUid: string
  agoraCloudProxyMode: 'Auto' | 'ForceUDP' | 'ForceTCP'
}

export const useTrialPatientVideoCallToken = () => {
  const [state, setState] = useState<State>()
  const [token, setToken] = useState<string | null>(null)
  const [videoCallUserUid, setVideoCallUserUid] = useState<number | null>(null)

  const { request: generateToken } = useGqlMutation(
    GenerateTrialPatientVideoCallTokenDocument,
    {
      onSuccess: ({ generateTrialPatientVideoCallToken: data }) => {
        setState({
          token: data.token,
          videoCallUserUid: data.videoCallUserUid,
          screenShareUserUid: data.screenShareUserUid,
          screenShareToken: data.screenShareToken,
          videoCallRoomUid: data.videoCallRoomUid,
          agoraCloudProxyMode: data.agoraCloudProxyMode,
        })
        setToken(token)
        setVideoCallUserUid(videoCallUserUid)
      },
    },
  )

  const setupJwtToken = useCallback(
    async (trialPatientUid: string) => {
      if (!trialPatientUid) return
      await generateToken({
        input: {
          trialPatientUid,
        },
      })
    },
    [generateToken],
  )

  return {
    data: state,
    setupJwtToken,
  }
}
